var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"fab":"","fixed":"","bottom":"","right":"","color":"primary"},on:{"click":function($event){_vm.isDialogVisible = true}}},[(_vm.isDialogVisible)?_c('role-dialog',{attrs:{"showDialog":_vm.isDialogVisible,"loading":_vm.loading},on:{"close":_vm.closeDialog,"submit":_vm.saveRole}}):_vm._e(),_c('v-icon',[_vm._v("mdi-plus")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }